module.exports = __webpack_public_path__ + "img/chevron-right.5b6ffe2b.svg";